import { Alert, Box, FormHelperText, Unstable_Grid2 as Grid } from '@mui/material';
import type { AlertColor } from '@mui/material/Alert/Alert';
import InfoTooltip from '../info-tooltip/index.js';
import Instructions from '../instructions/index.js';

export type FieldInfoProps = {
  readonly description?: string;
  readonly instructions?: string;
  readonly error?: string;
  readonly alert?: FieldAlert;
};

export type FieldAlert = {
  severity: AlertColor;
  message: string;
};

function FieldInfo({ description, instructions, error, alert }: FieldInfoProps) {
  if (!(instructions ?? description ?? error ?? alert)) {
    return null;
  }

  return (
    <>
      <Grid container>
        <Grid xs>
          <FormHelperText component="div">
            {error ?? (instructions && <Instructions value={instructions} />)}
          </FormHelperText>
        </Grid>
        {description && (
          <Grid
            sx={{
              display: 'flex',
              alignItems: 'center',
              mr: '14px',
              mt: '3px'
            }}
          >
            <Box sx={{ display: 'flex', marginLeft: 'auto' }}>
              <InfoTooltip top text={description} />
            </Box>
          </Grid>
        )}
      </Grid>
      {alert && (
        <Alert sx={{ mt: 1 }} severity={alert.severity}>
          {alert.message}
        </Alert>
      )}
    </>
  );
}

export default FieldInfo;
